import { render, staticRenderFns } from "./HeadersDetail.vue?vue&type=template&id=2ec535d3&"
import script from "./HeadersDetail.vue?vue&type=script&lang=js&"
export * from "./HeadersDetail.vue?vue&type=script&lang=js&"
import style0 from "./HeadersDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
